export default __webpack_public_path__ + "static/media/delete.c2c0605e.svg";